webpackJsonp([210488433442426],{

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(7);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _index = __webpack_require__(11);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _SlideshowFooter = __webpack_require__(8);
	
	var _SlideshowFooter2 = _interopRequireDefault(_SlideshowFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import { FullPage, Slide } from 'react-full-page'
	// import SlideshowControls from '../../components/SlideshowControls'
	
	
	var LandingPage = function (_React$Component) {
	    _inherits(LandingPage, _React$Component);
	
	    function LandingPage() {
	        _classCallCheck(this, LandingPage);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    LandingPage.prototype.render = function render() {
	
	        var id = 12;
	        var name = 'Behavioral Science Technologies';
	        var prev = '/brand-design/birth';
	        var next = '/brand-design/pennant-park';
	
	        // Dynamically generate slideshow
	        // let sliderImages = data[id].slideshow.map((img, idx) => {
	        //     return(
	        //         <Slide key={`image-${idx}`} className='slide-container' style={{backgroundImage: `url(${img})`}} />
	        //     )
	        // });
	
	        var sliderImages = _index2.default[id].slideshow.map(function (img, idx) {
	            return _react2.default.createElement('img', { key: 'image-' + idx, src: img });
	        });
	
	        return _react2.default.createElement(
	            'div',
	            { id: 'brand-landing' },
	            _react2.default.createElement(
	                _reactHelmet2.default,
	                null,
	                _react2.default.createElement(
	                    'title',
	                    null,
	                    'IMBIBE - Brand Design: ',
	                    name
	                ),
	                _react2.default.createElement('meta', { name: 'description', content: 'Brand Design: ' + name })
	            ),
	            sliderImages,
	            _react2.default.createElement(_SlideshowFooter2.default, { branding: true, prev: prev, next: next })
	        );
	    };
	
	    return LandingPage;
	}(_react2.default.Component);
	
	exports.default = LandingPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-brand-design-behavioral-science-technologies-js-53d66ff9c5f461c83469.js